// OwnerViewData.jsx
import React, { useEffect, useState } from 'react';
import CustomLoader from '../custom-ui/CustomLoader';
import { isArrayValue } from '../utility-files/data-util/DataHandling';
import TableContentHandler from '../qed-theme-module/TableContentHandler';
import CommonTable from '../pages/common-module/CommonTable';
import NoRecord from '../pages/common-module/NoRecord';
import ReplyCell from '../qed-theme-module/ReplyCell';
import RichTextView from '../qed-theme-module/RichTextView';
import { IMAGE_TYPES } from '../utility-files/default-values/DefaultValues';
import Image from '../pages/common-module/Image';

function OwnerViewData({ isShowModel, onClose, data }) {
  const [pending, setPending] = useState(false);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (isArrayValue(data)) {
      setMessages(data);
    } else {
      setMessages([]);
    }
  }, [data]);

  const viewMessageColumns = [
    {
      name: <TableContentHandler />,
      selector: (row) => row?.messagetype,
      sortable: true,
      cell: (row) => (
        <div className="btn-group" role="group" aria-label="Message Type">
          {row?.messagetype === "Received" ? (
            <Image src={IMAGE_TYPES.RECEIVE_ICON} alt="received" className="small-img" />
          ) : row?.messagetype === "Send" ? (
            <Image src={IMAGE_TYPES.SEND_ICON} alt="send" className="small-img"/>
          ) : (
            <span>-</span>
          )}
        </div>
      ),
    },
    {
      name: <TableContentHandler header={"Item"} />,
      selector: row => row?.itemname,
      cell: row => <>{row?.itemname}</>,
    },
    {
      name: <TableContentHandler header={"Token Id"} />,
      selector: row => row?.tokenid,
      cell: row => <>{row?.tokenid}</>,
    },
    {
      name: <TableContentHandler header={"Message"} />,
      selector: row => row?.message,
      sortable: true,
      cell: row => <RichTextView value={row?.message} maxLength={60} />,
    },
    {
      name: <TableContentHandler header={"Reply"} />,
      selector: row => row?.tokennotificationreply,
      cell: row => (
        <ReplyCell
          replies={row?.tokennotificationreply}
          message={row?.message}
          data={row}
        />
      ),
    },
  ];

  return (
    <>
      {pending && <CustomLoader />}
      {isShowModel && (
        <div
          className="modal fade show d-block bd-example-modal-sm page-over"
          tabIndex="0"
          aria-hidden="true"
          data-bs-keyboard="false"
          data-bs-backdrop="static"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg OwnerData_tbl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">View Message</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => onClose()}
                ></button>
              </div>

              <div className="plans-modal-table">
                <CommonTable
                  columns={viewMessageColumns}
                  data={messages}
                  fixedHeader={true}
                  fixedHeaderScrollHeight={"400px"}
                  progressPending={pending}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<NoRecord />}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default OwnerViewData;
